import p from "../../../@babel/runtime/helpers/esm/typeof2.mjs";
import b from "../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import v from "../../../@babel/runtime/helpers/esm/toConsumableArray2.mjs";
import d from "../../../@babel/runtime/helpers/esm/toArray.mjs";
import s from "./get.mjs";
function h(r, o, e, t) {
  if (!o.length)
    return e;
  var c = d(o), i = c[0], n = c.slice(1), a;
  return !r && typeof i == "number" ? a = [] : Array.isArray(r) ? a = v(r) : a = b({}, r), t && e === void 0 && n.length === 1 ? delete a[i][n[0]] : a[i] = h(a[i], n, e, t), a;
}
function m(r, o, e) {
  var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return o.length && t && e === void 0 && !s(r, o.slice(0, -1)) ? r : h(r, o, e, t);
}
function j(r) {
  return p(r) === "object" && r !== null && Object.getPrototypeOf(r) === Object.prototype;
}
function y(r) {
  return Array.isArray(r) ? [] : {};
}
var O = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function k() {
  for (var r = arguments.length, o = new Array(r), e = 0; e < r; e++)
    o[e] = arguments[e];
  var t = y(o[0]);
  return o.forEach(function(c) {
    function i(n, a) {
      var f = new Set(a), u = s(c, n), l = Array.isArray(u);
      if (l || j(u)) {
        if (!f.has(u)) {
          f.add(u);
          var g = s(t, n);
          l ? t = m(t, n, []) : (!g || p(g) !== "object") && (t = m(t, n, y(u))), O(u).forEach(function(A) {
            i([].concat(v(n), [A]), f);
          });
        }
      } else
        t = m(t, n, u);
    }
    i([]);
  }), t;
}
export {
  m as default,
  k as merge
};
//# sourceMappingURL=set.mjs.map
